export default "__VITE_ASSET__8404c0f4__"